import { Button } from '@factorialco/deprecated-design-system'

import Modal from 'modules/core/components/Modal'
import i18n from 'modules/core/lib/i18n'

interface Props {
  onClose: () => void
  onSubmit: () => void
}

export const DeleteTaskModal = ({ onClose, onSubmit }: Props) => {
  return (
    <Modal
      title={i18n.t('tasks.modals.delete.title')}
      description={i18n.t('tasks.modals.delete.description')}
      illustration="delete"
      onClose={onClose}
      footer={
        <>
          <Button type="secondary" onClick={onClose}>
            {i18n.t('tasks.modals.delete.cancel')}
          </Button>
          <Button type="primary" onClick={onSubmit}>
            {i18n.t('tasks.modals.delete.submit')}
          </Button>
        </>
      }
    ></Modal>
  )
}
